// extracted by mini-css-extract-plugin
export default {"container":"MoveCompany_container__S5nnq","producerName":"MoveCompany_producerName__qvBZO","label":"MoveCompany_label__Is460","button":"MoveCompany_button__jYn7b"};